<template>
  <Dialog title="应用申请" width="500px" :visible.sync="dialogVisible" dialogType="dialog" showClose>
    <form class="apply-form">
      <div class="apply-title">应用申请</div>  
      <div class="form-group">
        <label class="name-label">应用名称</label>
        <div class="controls">
          <div class="input-div">
            <input type="text" autocomplete="off" class="form-control" placeholder="16个字符以内" v-model="app_name">
            <span class="apply-tip">例如您的网站名称，方便您进行用途识别</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label">备注</label>
        <div class="controls">
          <div class="input-div">
            <input type="text" autocomplete="off" class="form-control" placeholder="50个字符以内" v-model="remark">
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="controls">
          <button type="button" class="btn-apply" @click="submitData">立即创建</button>
        </div>
      </div>
    </form>
    <Dialog width="300px" :visible.sync="dialogTipVisible" :message="tip_msg"  dialogType="message"></Dialog>
  </Dialog>
</template>
<script>

import { createPromotion } from '@/api/promotion'
import Dialog from '@/components/Dialog'
export default {
  name: 'CreateApply',
  components: {
    Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false   
    },
  },
  data() {
    return {
      app_name: '',
      remark:'',
      dialogVisible: this.visible,
      dialogTipVisible: false,
      tip_msg: undefined
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.dialogTipVisible = false 
        this.app_name = undefined
      } 
    },
    dialogVisible(val) {
      this.app_name = this.remark = ''
      this.$emit('change', val)
    }
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown, true)// 开启监听键盘按下事件
  },
  methods: {
    handleKeyDown(e) {
      let key = null
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      if (key === 13) {
        this.submitData()
      }
    },
    submitData() {
      if (this.isLock()) {
        return;
      }
      this.lock();
      this.vaildForm().then(valid => {
        if (valid) {
          createPromotion({
            app_name:this.app_name,
            remark:this.remark
          }).then(response => {
            this.dialogVisible = false;
            this.$Message.success(response.msg)
            this.unlock()
            this.$emit('refreshList');
          }).catch(error =>{
            this.unlock()
            console.log(error)
          })
        } else {
          this.unlock();
        }
      }) 
    },
    lock() {
      this.isDoing = true;
    },
    unlock() {
      this.isDoing = false;
    },
    isLock() {
      return this.isDoing
    },
    // 校验应用名称
    async vaildForm() {
      this.tip_msg = undefined
      this.dialogTipVisible = false
      if(!this.app_name || this.app_name === '') {
        this.tip_msg = '应用名称不能为空'
      } else if (this.app_name.length > 16){
        this.tip_msg = '应用名称16个字符以内'
      }
      if (this.tip_msg) {
        this.message(this.tip_msg)
        return false
      } else {
        return true
      }
    },
    // 文本提示
    message(msg){
      this.tip_msg = msg
      this.dialogTipVisible = true
    }
  }
}
</script>
<style scoped>
.apply-form{
  margin-top: 50px;
}
.apply-title{
  text-align: center;  
  margin: 15px auto 25px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-group{
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 0;
}
.form-group::before,.form-group::after{
  content: " ";
  display: table;
  box-sizing: border-box;
}
.name-label {
  width: 20%;
  float: left;
  text-align: right;
  color: #222222;
  font-size: 13px;
  font-weight: normal;
  line-height: 30px;
  padding-right: 10px;
}
.controls{
  overflow: hidden;
  margin-left: 20%;
  margin-bottom: 15px;
}
.input-div {
  width: 80%;
  float: left;
}
.form-control {
  border-color: #666666;
  height: 33px;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  border: 1px solid #ccc;
}
input{
  font: inherit;
  margin: 0;
}
.apply-tip{
  color: #999999;
  font-size: 12px;
}
.btn-apply{
  border-radius: 4px;
  background: #199ED8;
  color: #FFFFFF;
  padding: 10px 50px;
  font-size: 15px;
  line-height: 1.3333333;
  margin-top: 20px;
  cursor: pointer;
  margin-left: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/document/user/CreateApply.vue